import script from "./RacingPageFixtureBook.vue?vue&type=script&setup=true&lang=js"
export * from "./RacingPageFixtureBook.vue?vue&type=script&setup=true&lang=js"

import "./RacingPageFixtureBook.vue?vue&type=style&index=0&id=25ef8a62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25ef8a62"]])

export default __exports__